module.exports = __webpack_public_path__ + "img/time.1f2f77ce.svg";